export class TrafficNewsRss {
    constructor(stateFilterContainer, infoTypeFilterContainer, rssLink, resetButton) {
        this.stateFilterContainer = stateFilterContainer;
        this.infoTypeFilterContainer = infoTypeFilterContainer;
        this.rssLink = rssLink;
        this.resetButton = resetButton;
        this.baseHref = this.rssLink.href;
        this.setBaseRssLink();
        this.initListeners();
    }
    initListeners() {
        const initFilterClick = (container) => {
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (target.tagName !== 'BUTTON')
                    return;
                this.updateRssLink();
            });
        };
        initFilterClick(this.stateFilterContainer);
        initFilterClick(this.infoTypeFilterContainer);
        if (this.resetButton) {
            this.resetButton.addEventListener('click', e => {
                e.preventDefault();
                this.setBaseRssLink();
            });
        }
    }
    setBaseRssLink() {
        this.rssLink.href = this.baseHref;
    }
    getActiveValues(container) {
        return Array.from(container.querySelectorAll('button.active'))
            .map(btn => btn.getAttribute('data-value'))
            .filter(Boolean);
    }
    updateRssLink() {
        const selectedStates = this.getActiveValues(this.stateFilterContainer);
        const selectedTypes = this.getActiveValues(this.infoTypeFilterContainer);
        const hasStateFilter = selectedStates.length > 0 && !selectedStates.includes('all');
        const hasTypeFilter = selectedTypes.length > 0;
        if (!hasStateFilter && !hasTypeFilter) {
            this.setBaseRssLink();
            return;
        }
        let url = '/verkehrsmeldungen';
        const segments = [];
        if (hasStateFilter) {
            segments.push(`state=${selectedStates.join(',')}`);
        }
        if (hasTypeFilter) {
            segments.push(`type=${selectedTypes.join(',')}`);
        }
        if (segments.length > 0) {
            url += `~${segments.join('~')}~`;
        }
        url += '.xml';
        this.rssLink.setAttribute('href', url);
    }
}
export function initTrafficNewsRss() {
    const stateFilterContainer = document.querySelector('.state-filter-buttons');
    const infoTypeFilterContainer = document.querySelector('.infotype-filter-buttons');
    const rssLink = document.querySelector('.js-rss-feed');
    const resetButton = document.querySelector('.traffic-news-filter__reset');
    if (!stateFilterContainer || !infoTypeFilterContainer || !rssLink)
        return;
    new TrafficNewsRss(stateFilterContainer, infoTypeFilterContainer, rssLink, resetButton || undefined);
}
